import { approveSpaceMembershipRequestGQLMutation, declineSpaceMembershipRequestGQLMutation, getMemberSpaceMembershipRequestGQLQuery, requestSpaceMembershipGQLMutation, spaceMembershipRequestsGQLQuery, } from '../../graphql/index.js';
export class SpaceMembershipClient {
    constructor(client) {
        this.client = client;
    }
    async getMemberRequests(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: getMemberSpaceMembershipRequestGQLQuery(fields),
            customToken: accessToken,
            variables,
        });
        return result.memberSpaceMembershipRequest;
    }
    async getRequests(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: spaceMembershipRequestsGQLQuery(fields),
            customToken: accessToken,
            variables,
        });
        return result.spaceMembershipRequests;
    }
    async request(variables, fields = 'basic', accessToken) {
        const result = await this.client.authorizedRequest({
            query: requestSpaceMembershipGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return result.requestSpaceMembership;
    }
    async approveRequest(variables, fields = 'basic', accessToken) {
        const request = await this.client.authorizedRequest({
            query: approveSpaceMembershipRequestGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return request.approveSpaceMembershipRequest;
    }
    async declineRequest(variables, fields = 'basic', accessToken) {
        const request = await this.client.authorizedRequest({
            query: declineSpaceMembershipRequestGQLMutation(fields),
            variables,
            customToken: accessToken,
        });
        return request.declineSpaceMembershipRequest;
    }
}
//# sourceMappingURL=spaceMembership.client.js.map